import React from 'react';
import './Homepage.css';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate, Link } from 'react-router-dom';

const Homepage = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="landing-page" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <main>
        <div className="welcome-card">
          <h1>{t('welcome')}</h1>
          <p>{t('homepage_desc')}</p>
          <div className="actions">
            <button className="login-btn" onClick={() => navigate('/login')}>
              {t('login')}
            </button>
            <button className="register-btn" onClick={() => navigate('/signup')}>
              {t('register')}
            </button>
          </div>
        </div>
      </main>
      <footer>
        <div className="footer-links">
          <Link to="/privacy">{language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}</Link>
          <span>|</span>
          <Link to="/terms">{language === 'ar' ? 'الشروط والأحكام' : 'Terms of Service'}</Link>
          <span>|</span>
          <Link to="/return">{language === 'ar' ? 'سياسة الاسترجاع' : 'Return Policy'}</Link>
          <span>|</span>
          <Link to="/pricing">{language === 'ar' ? 'الأسعار' : 'Pricing'}</Link>
          <span>|</span>
          <Link to="/about">{language === 'ar' ? 'من نحن' : 'About Us'}</Link>
          <span>|</span>
          <Link to="/contact">{language === 'ar' ? 'اتصل بنا' : 'Contact Us'}</Link>
          <span>|</span>
          <Link to="/faq">{language === 'ar' ? 'الأسئلة الشائعة' : 'FAQ'}</Link>
          <span>|</span>
          <Link to="/guide">{language === 'ar' ? 'دليل المستخدم' : 'User Guide'}</Link>
          <span>|</span>
          <Link to="/features">{language === 'ar' ? 'الميزات' : 'Features'}</Link>
          <span>|</span>
          <Link to="/delete-account">{language === 'ar' ? 'حذف الحساب' : 'Delete Account'}</Link>
        </div>
        <div className="footer-copy">
          {language === 'ar'
            ? 'جميع الحقوق محفوظة © AT Delivery 2025'
            : 'All rights reserved © AT Delivery 2025'}
        </div>
      </footer>
    </div>
  );
};

export default Homepage;